export default (value) => {
    if (value === null || value === undefined)
        return '-';
    if (typeof value === 'object')
        return '-';
    return String(value) || '-';
};
